import React from "react";
import TableCell from "../../../../../ui/widgets/table/cell";
import TableHead from "../../../../../ui/widgets/table/head";
import TableRow from "../../../../../ui/widgets/table/row";
import TableSortLabel from "../../../../../ui/widgets/table/sortLabel";
import { TableHeaderProps } from "./types";
import { CardholderTableRow } from "../body/rowGenerator.tsx";

export default function Header({
  orderBy,
  order,
  rows,
  onSortChange,
}: TableHeaderProps): React.JSX.Element {
  const createSortHandler =
    (rowId: keyof CardholderTableRow) => (event: React.MouseEvent) => {
      onSortChange(event, rowId);
    };

  return (
    <TableHead>
      <TableRow key="1">
        {rows.map((row) => (
          <TableCell
            key={row.id}
            sortDirection={orderBy === row.id ? order : null}
          >
            {row.sortable ? (
              <TableSortLabel
                active={orderBy === row.id}
                direction={order}
                onClick={createSortHandler(row.id)}
              >
                {row.label}
              </TableSortLabel>
            ) : (
              <React.Fragment>{row.label}</React.Fragment>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
